import { html } from "lit";
import { query } from "lit/decorators.js";
import "./@a11y/focus-trap/focus-trap.js";
import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let DsfFocusTrap = class extends BaseComponent {
  connectedCallback() {
    super.connectedCallback();
    this.dsf_focus_selector && requestAnimationFrame(() => {
      this.focusFirstElement();
    });
  }
  focusFirstElement() {
    if (this.dsf_focus_selector) {
      const elements = this.trap.getFocusableElements();
      const firstElement = elements.find((e) => {
        try {
          return e.matches(this.dsf_focus_selector);
        } catch {
          return false;
        }
      });
      firstElement == null ? void 0 : firstElement.focus();
    }
  }
  render() {
    return html` <dsf-focus-trap-base class="flex-auto" id="trap">
      <slot></slot>
    </dsf-focus-trap-base>`;
  }
};
DsfFocusTrap.properties = {
  dsf_focus_selector: { type: String }
};
__decorateClass([
  query("#trap")
], DsfFocusTrap.prototype, "trap", 2);
DsfFocusTrap = __decorateClass([
  defineElement("dsf-focus-trap")
], DsfFocusTrap);
export {
  DsfFocusTrap
};
